export default import.meta.ROLLDOWN_FILE_URL_txjcXHUqlc7E7r6yoMfYyQ